import { render } from "./DonationReceiptModal.vue?vue&type=template&id=1a8d9932&lang=true"
import script from "./DonationReceiptModal.vue?vue&type=script&lang=js"
export * from "./DonationReceiptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__